const testimonials = [
  {
    id: 1,
    name: 'Jeff Scott',
    location: 'British Columbia, Canada',
    image: 'https://static.readdy.ai/image/1c1714daf9c4102bfceb8d84a95c03a8/412399610abd23bc8df21d6a0fc1a128.jpeg',
    quote: 'It adds value to my life in ways you are not able to measure. And it continues to surprise me with where I end up! My world has expanded to unimaginable places. It gives me the freedom to explore again, with confidence.',
  },
];

export default function Community() {
  return (
    <section id="community" className="py-24 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-4 tracking-tight">USER STORIES</h2>
          <p className="text-xl text-gray-400">Hear from the IND Mobility family</p>
        </div>

        <div className="grid grid-cols-1 max-w-xl mx-auto gap-8 mb-20">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-zinc-900 p-5 md:p-8 rounded-lg flex flex-col">
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 flex items-center justify-center rounded-full overflow-hidden mr-4 shrink-0">
                  <img
                    src={t.image}
                    alt={t.name}
                    width="56"
                    height="56"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-sm">{t.name}</h3>
                  <p className="text-xs text-gray-400 mt-0.5">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed italic text-sm flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex mt-5 text-teal-400 gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
